import { Button, Modal } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import Api from '../../../api/Api';
import { StoreContext } from '../../../store/store';
import SignUp from '../../../views/header/components/SignUpButton';
import { MarkerItemToRestore } from '../../../typings/home';
import styles from './LoginSpectraModal.module.scss'
import { DT0Format, MARKERS_TO_RESTORE } from '../../../generic/StaticVariable';
import image from '../../../assets/image/digital-data-ocean-.jpg';

export default function AuthenticateModal() {
  const {
    setShowLogin,
    showLogin,
    markerCollections,
    showSpectraModal,
    setShowSpectraModal
  } = useContext(StoreContext);

  const [popupKey, setPopupKey] = useState('')
  const [showSignUp, setShowSignUp] = useState(false);

  useEffect(() => {
    const point = markerCollections.find((x) => x.active)
    setPopupKey(point?.dataset ?? '')
  }, [])

  const handleSignUp = React.useCallback(() => {
    setShowSignUp(true);
  }, []);

  const handleOk = () => {
    saveMarkerItems();
    window.location.href = `${Api.SERVER_DOMAIN}${Api.IISSite}/auth/signin`;
    setShowLogin(false);
    setShowSpectraModal(false);
  };

  const saveMarkerItems = () => {
    if (markerCollections && markerCollections.length > 0) {
      const markerCollectionsToRestore: MarkerItemToRestore[] = markerCollections.map(m => {
        return {
          id: m.id,
          label: m.label,
          active: m.active,
          coordinates: m.coordinates,
          downloadPage: m.downloadPage!.map(x => {
            return {
              datasetId: x.datasetId,
              dateRange: [x.dateRange[0].format(DT0Format), x.dateRange[1].format(DT0Format)],
              radioKey: x.radioKey
            };
          }),
          fwePointName: m.fwePointName
        }
      });
      localStorage.setItem(MARKERS_TO_RESTORE, JSON.stringify(markerCollectionsToRestore));
    }
  };

  const handleCancel = () => {
    setShowLogin(false);
    setShowSpectraModal(false)
  };

  const signUpCompleted = () => {
    saveMarkerItems();
    setShowLogin(false);
    setShowSpectraModal(false)
  };

  return (
    <>
      <SignUp open={showSignUp} setOpen={setShowSignUp} afterSignUp={signUpCompleted} />
      {!showSpectraModal && (
        <Modal
          title="Please authenticate"
          visible={showLogin}
          onOk={handleOk}
          onCancel={handleCancel}
          footer={[
            <Button key="signUp" type="default" onClick={handleSignUp}>Sign up</Button>,
            <Button key="signIn" type="primary" onClick={handleOk}>
              Sign in
            </Button>,
          ]}
        >
          Please sign in or sign up in order to continue.        
        </Modal>
      )}
      {showSpectraModal && (
        <Modal
          className={`LoginOrRegisterModal ${styles.LoginOrRegisterModal}`}
          title={[
            <div
              className={styles.modalTitle}
              key={'loginOrRegisterModal-title-container'}
            >
              <h1>2D Wave Spectra</h1>
            </div>,
          ]}
          footer={[]}
          width={'65vw'}
          visible={showSpectraModal}
          onCancel={handleCancel}
          maskClosable={true}
        >
          <div className={styles.LoginOrRegisterModalContent}>
            <div className={styles.contactText}>
              {/* This is special case for Spectra Dataset */}
              {popupKey === 'waterdata-dataset-TNW_SW_CFSR' ? (
                <>
                  <h1>Unlock Your Free Access to 2D Wave Spectra Dataset</h1>
                  <div className={styles.leftContainer}>
                    <div>
                      <p>
                        We&apos;re excited to provide the 2D Wave Spectra Dataset for
                        free. To access it, you&apos;ll need a user account
                      </p>
                      <br />
                      <p>
                        Please log in or register for a complimentary account to get
                        started.
                      </p>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <h1>Unlock Your Access to 2D Wave Spectra Dataset</h1>
                  <div className={styles.leftContainer}>
                    <div>
                      <p>
                        Please log in or register for a complimentary account to get
                        started.
                      </p>
                    </div>
                  </div>
                </>
              )}
              <div className={styles.buttonContainer}>
                <Button
                  type="primary"
                  className={styles.loginBtn}
                  shape={'round'}
                  size={'large'}
                  onClick={handleOk}
                >
                  Log in
                </Button>
                <Button
                  type="default"
                  className={styles.registerBtn}
                  shape={'round'}
                  size={'large'}
                  onClick={handleSignUp}
                >
                  Register
                </Button>
              </div>
            </div>
            <div className={styles.rightContainer}>
              <img src={image} alt="image of digital ocean" />
            </div>
          </div>
        </Modal>
      )}
    </>
  );

}
